import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { isEmpty } from 'validate.js';
import useAsyncEffect from 'use-async-effect';

import { Cabbage } from '../../../ui-library/typography';
import { CenterContentBox } from '../../../ui-library/layout';
import FabricDetailPage from '../product-details-fabrics/FabricDetailPage';
import GenericEmptyState from '../GenericEmptyState';
import { getProductListing } from './storefront.utils';
import FabricCard from '../../website/FabricCard';
import { Space } from '../../../ui-library/space';
import { STR_STORE } from '../../../utils/constants';
import StyledWideContainer from '../../../ui-library/styled/StyledWideContainer';
import useQuery from '../../../utils/useQuery';
import useScroll from '../../../utils/useScroll';
import NotFoundPage from '../../website/NotFoundPage';

// Example URL
// shop/fabrics?brand=harrisons&bunch=FINE%20CLASSICS&cloth_code=46759
const FabricsStorefrontPage = () => {
  const [productListing, setProductListing] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [showTitle, setShowTitle] = useState(false);

  const { scrollToTop } = useScroll();
  const query = useQuery();
  const brand = query.get('brand');
  const bunch = query.get('bunch');
  const cloth_code = query.get('cloth_code');

  useAsyncEffect(async (isMounted) => {
    const tProductListing = await getProductListing({
      type: 'fabrics',
      brand,
      bunch,
      cloth_code,
    });
    if (!isMounted()) return;
    const isBrandCard = isEmpty(brand) && isEmpty(bunch) && isEmpty(cloth_code);
    isBrandCard ? setShowTitle(false) : setShowTitle(true);

    setProductListing(tProductListing);
    setHasError(tProductListing ? false : true);

    scrollToTop();
  }, []);

  if (isEmpty(productListing) && !hasError) {
    return <GenericEmptyState />;
  }
  if (hasError) {
    return <NotFoundPage />;
  }
  if (!isEmpty(productListing) && !isEmpty(cloth_code)) {
    return <FabricDetailPage product={productListing} />;
  }

  return (
    <StyledWideContainer style={{ maxWidth: '1200px' }}>
      <CenterContentBox>
        <Cabbage as='h1'>{STR_STORE}</Cabbage>
      </CenterContentBox>
      <Row className='mt-4'>
        {productListing.map((item) => {
          return (
            <Col key={item.name} sm={12} md={4} className='mb-4'>
              <FabricCard
                product={item}
                borderRadius='12px'
                showTitle={showTitle}
              />
            </Col>
          );
        })}
      </Row>

      <Space size={12} />
    </StyledWideContainer>
  );
};

export default FabricsStorefrontPage;
